const catalog =[
{
    id:1,
    image:'/scroll_image/image_s_1.jpg',
    price:2500,
    description:"Price per 100 sq.ft = 590"
    
},

{
    id:2,
    image:'/scroll_image/image_s_2.jpg',
    price:2500,
    description:"Price per 100 sq.ft = 390"
    
},
{
    id:3,
    image:'/scroll_image/image_s_3.jpg',
    price:2500,
    description:"Price per 100 sq.ft = 533"
    
},
{
    id:4,
    image:'/scroll_image/image_s_4.jpg',
    price:2500,
    description:"Price per 100 sq.ft = 588"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_31.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_32.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_33.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_34.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_35.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_36.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_37.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_38.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_39.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_40.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_41.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_42.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_43.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_44.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_45.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_46.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_47.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_48.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_49.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_50.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}
,
{
    id:31,
    image:'/scroll_image/image_s_51.jpg',
    price:2500,
    description:"Price per sq.ft = 400"
    
}

]
export default catalog; 